"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactMaskedinput = _interopRequireDefault(require("react-maskedinput"));

var _reactInputMask = _interopRequireDefault(require("react-input-mask"));

var _masks = require("../../../utils/masks");

var _styles = require("../../../utils/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Input = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var className = props.className,
      disabled = props.disabled,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      onChange = props.onChange,
      defaultValue = props.defaultValue,
      hasValue = props.hasValue,
      hasError = props.hasError,
      name = props.name,
      id = props.id,
      placeholder = props.placeholder,
      mask = props.mask,
      size = props.size,
      type = props.type,
      value = props.value,
      readOnly = props.readOnly,
      uppercase = props.uppercase,
      regexMask = props.regexMask,
      maskPlaceholder = props.maskPlaceholder,
      right = props.right,
      rightClassName = props.rightClassName;
  var handleChange = (0, _react.useCallback)(function (e) {
    var evt = _objectSpread({}, e);

    if (evt.target.value) {
      evt.target.value = (0, _masks.removeSpaces)(evt.target.value);
    }

    if (onChange) onChange(evt);
  }, [onChange]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    var evt = _objectSpread({}, e);

    if (evt.target.value) {
      evt.target.value = (0, _masks.removeSpaces)(evt.target.value);
    }

    if (onBlur) onBlur(evt);
  }, [onBlur]);

  var classes = _classnames.default.apply(void 0, ['rounded-lg border-2 border-solid border-gray-200 py-3 pl-3 pr-8 w-full', 'appearance-none tracking-wider font-normal', 'focus:outline-none focus:shadow-base'].concat(_toConsumableArray((0, _styles.getStyleClasses)(hasValue, disabled)), [hasError && 'border-red-400', uppercase && 'uppercase', className]));

  var MaskedInputComponent = regexMask ? _reactInputMask.default : _reactMaskedinput.default;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "relative"
  }, mask && (regexMask || size) ? /*#__PURE__*/_react.default.createElement(MaskedInputComponent, {
    type: type,
    id: id,
    disabled: disabled,
    onFocus: onFocus,
    onBlur: mask && regexMask ? handleBlur : onBlur,
    onChange: mask && regexMask ? handleChange : onChange,
    className: classes,
    name: name,
    defaultValue: defaultValue,
    placeholder: placeholder,
    mask: mask,
    size: size,
    placeholderChar: regexMask ? undefined : ' ',
    maskPlaceholder: maskPlaceholder,
    ref: ref,
    value: value,
    readOnly: readOnly
  }) : /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    id: id,
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange,
    className: classes,
    name: name,
    defaultValue: defaultValue,
    placeholder: placeholder,
    ref: ref,
    value: value,
    readOnly: readOnly
  }), right && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('absolute top-0 bottom-0 right-0 min-h-full inline-flex justify-center items-center pr-3 -mb-1 cursor-pointer', rightClassName)
  }, right));
});

Input.propTypes = {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onChange: _propTypes.default.func,
  defaultValue: _propTypes.default.string,
  hasValue: _propTypes.default.bool,
  hasError: _propTypes.default.bool,
  name: _propTypes.default.string,
  id: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.string,
  type: _propTypes.default.string,
  value: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  uppercase: _propTypes.default.bool,
  regexMask: _propTypes.default.bool,
  maskPlaceholder: _propTypes.default.string,
  right: _propTypes.default.node,
  rightClassName: _propTypes.default.string
};
Input.defaultProps = {
  name: '',
  uppercase: false,
  regexMask: false,
  maskPlaceholder: ''
};
var _default = Input;
exports.default = _default;